import { onMounted, watch } from 'vue'
import { useHead } from '@vueuse/head'
import { useSinglePageStore } from '@/stores/singlePageStore'
import { storeToRefs } from 'pinia'

export function usePageSEO(slug: string) {
    const singlePageStore = useSinglePageStore()
    const { page } = storeToRefs(singlePageStore)

    onMounted(() => {
        singlePageStore.fetchPage(slug)
    })

    watch(page, (data) => {
        if (!data) {
            useHead({
                title: '',
                meta: [
                    { name: 'description', content: '' },
                    { property: 'og:title', content: '' },
                    { property: 'og:description', content: '' },
                    { property: 'og:image', content: '' },
                    { property: 'og:type', content: 'website' }
                ]
            })
            return
        }
        useHead({
            title: data.seoTitle || data.title,
            meta: [
                { name: 'description', content: data.seoDescription || '' },
                { property: 'og:title', content: data.seoTitle || data.title },
                { property: 'og:description', content: data.seoDescription || '' },
                {
                    property: 'og:image',
                    content: data.imageSet?.['760w'] || `${window.location.origin}/assets/logo_luxury_yachts_red.png`
                },
                { property: 'og:type', content: 'website' }
            ]
        })
    }, { immediate: true })
}
